import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input } from "@headlessui/react";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { CHANGE_ARCHIVE_TASK_DONE_FILTER, SET_ARCHIVE_FILTERED_PIPELINE, SET_ARCHIVE_SEARCH_VALUE, } from "../../../constants";
import { ArchiveContext } from "../../../providers/ArchiveContextProvider";
import { WPQTArchiveDoneFilter } from "../../../types/enums";
import { PipelineFilterSelect } from "../../common/Select/PipelineFilterSelect/PipelineFilterSelect";
import { WPQTSelect } from "../../common/Select/WPQTSelect";
import { WPQTFilter } from "../WPQTFilter";
function ArchiveFilter() {
    const { state: { archiveSearchValue, archiveFilteredPipelineId, archiveTaskDoneFilter, }, archiveDispatch, } = useContext(ArchiveContext);
    const setArchiveSearchValue = (event) => {
        archiveDispatch({
            type: SET_ARCHIVE_SEARCH_VALUE,
            payload: event.target.value,
        });
    };
    const onSelectionChange = (selection) => {
        archiveDispatch({
            type: SET_ARCHIVE_FILTERED_PIPELINE,
            payload: selection,
        });
    };
    const convertToWPQTArchiveDoneFilter = (selection) => {
        switch (selection) {
            case WPQTArchiveDoneFilter.All:
                return WPQTArchiveDoneFilter.All;
            case WPQTArchiveDoneFilter.Completed:
                return WPQTArchiveDoneFilter.Completed;
            case WPQTArchiveDoneFilter.NotCompleted:
                return WPQTArchiveDoneFilter.NotCompleted;
            default:
                throw new Error(`Invalid selection: ${selection}`);
        }
    };
    return (_jsxs(WPQTFilter, { title: __("Filter tasks", "quicktasker"), children: [_jsx(Input, { type: "text", value: archiveSearchValue, onChange: setArchiveSearchValue }), _jsx(PipelineFilterSelect, { selectedOptionValue: archiveFilteredPipelineId, selectionChange: onSelectionChange }), _jsx(WPQTSelect, { allSelector: false, selectedOptionValue: archiveTaskDoneFilter, options: [
                    {
                        label: __("All status", "quicktasker"),
                        value: WPQTArchiveDoneFilter.All,
                    },
                    {
                        label: __("Completed", "quicktasker"),
                        value: WPQTArchiveDoneFilter.Completed,
                    },
                    {
                        label: __("Not completed", "quicktasker"),
                        value: WPQTArchiveDoneFilter.NotCompleted,
                    },
                ], onSelectionChange: (selection) => {
                    const filter = convertToWPQTArchiveDoneFilter(selection);
                    archiveDispatch({
                        type: CHANGE_ARCHIVE_TASK_DONE_FILTER,
                        payload: filter,
                    });
                } })] }));
}
export { ArchiveFilter };
